import { Theme } from "@mui/material";
import { colors } from "../../constants/colors";

const styles = {
  '& #faqs-section': {
    color: colors.black
  }
};

const templateStyles: any = (theme?: Theme) => styles;

export default templateStyles;